import React, { useState } from "react"
import {TextArea} from "devextreme-react";
import { InputWrapper } from "./InputWrapper";
import { FormActionButtons } from "./FormActionButtons";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentCase } from "../../../redux/currentCase/selectors";
import { advanceFactoryCase } from "../../../redux/currentCase/thunks";
import { errorHandler } from "../../../commonFunctions/errorHandler";
import { openModal } from "../../../redux/modal/modalSlice";
import { validateAdvanceFactoryCaseData } from "../case/formValidationFunctions";
import { regressFactoryCase } from "../../../redux/caseForms/thunks";
import { getCommentByCaseId } from "../../../redux/contract/thunks";


function AdvanceFactoryCaseForm(props){
    const {showAdvanceFactoryCaseForm, setShowAdvanceFactoryCaseForm, showRegressFactoryCaseForm, setShowRegressFactoryCaseForm, handleShowForms, setDisabledButtom} = props;
    const currentCase = useSelector(selectCurrentCase)
    const [disabledActionButtons, setDisabledActionButtons] = useState(false)
    const dispatch = useDispatch();
    const isAdvance = showAdvanceFactoryCaseForm


    const [formData, setFormData] = useState({
        comment: "",
    })

    async function handleSubmit(){
        setDisabledActionButtons(true);
        const submitData = {...formData, caseId: currentCase.caseId, processId: currentCase.factoryProcessId, expedient: currentCase.caseNumber}

        if(!validateAdvanceFactoryCaseData(submitData, dispatch)){
            setDisabledActionButtons(false);
            return
        }
        const factoryAction = isAdvance? advanceFactoryCase : regressFactoryCase;

        dispatch(factoryAction({body: submitData})).then(
            response=>{
                if (response.payload)
                {
                    setFormData(
                        {
                            comment: "",
                        }
                    )
                    setDisabledButtom(prevState=>({...prevState, advanceFactoryCase: true}))
                    dispatch(getCommentByCaseId({query: `?caseId=${currentCase.caseId}`}));
                }
                setDisabledActionButtons(false);
                setShowAdvanceFactoryCaseForm(false)
                setShowRegressFactoryCaseForm(false)
            }
        )

    }
    
    return(
        <div className={"case-header-form"} style={showAdvanceFactoryCaseForm || showRegressFactoryCaseForm ? {position:"absolute",top:0,zIndex:1500,right: 66,width:"280px",height:"auto",backgroundColor:"#c4e2f7",padding:"15px"}:{display:"none"}}>
                <InputWrapper label={"Comentario fábrica"} labelColor={"#3B5158"}>
                    <TextArea height={150} value={formData.comment} onValueChanged={(e)=>setFormData(prevState=>({...prevState, comment: e.value}))}/>
                </InputWrapper> 
                <FormActionButtons
                    cancelFunction={()=>handleShowForms(isAdvance? "advanceFactoryCase" : "regressDactoryCase")}
                    submitFunction={handleSubmit}
                    submitText={ isAdvance ? "Avanzar caso fábrica" :  "Retroceder caso fábrica"}
                    disabled={disabledActionButtons}
                />
        </div>
    )
}

export {AdvanceFactoryCaseForm}